import { MutableRefObject, Ref } from "react";

export const mergeRefs = <T>(...refs: (Ref<T> | undefined | null)[]) => {
  return (el: T | null) => {
    for (const ref of refs) {
      if (!ref) continue;
      if (typeof ref === "function") ref(el);
      else (ref as MutableRefObject<T | null>).current = el;
    }
  };
};
